import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ReadReceiptsOption: LazyOption = createLazyOption(
    {
        key: 'readReceipts',
        titleStringKey: 'optionTitle_readReceipts',
        searchTermsStringKey: 'optionTitle_readReceipts',
        allowedOptionKeys: ['ReadReceipts'],
    },
    lazyFullModule,
    m => m.default
);
export default ReadReceiptsOption;
